<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Agents</h4>
            <h6 class="card-subtitle">&nbsp;</h6>
            <data-table
              :columns="headers"
              fieldName="agents"
              :variables="variables"
              :query="collections"
            >
              <div slot="filter" class="filter-controls pull-right">
                <select v-model="agentId" class="form-control" id="agent-filter">
                  <option selected value="0">All Agents</option>
                  <option v-for="agent of agentsName" :key="agent.id" :value="agent.id">{{agent.name}}</option>
                </select>
                <select v-model="period" class="form-control" id="period-filter">
                  <option v-for="period of periods" :key="period.value" :value="period.value">{{period.title}}</option>
                </select>
              </div>
            </data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable';

import AGENTS from '@/graphql/Reports/Agents.gql';
import AGENTS_NAME from '@/graphql/Reports/AgentsName.gql';

export default {
  name: 'Agents',
  components: {
    DataTable,
  },
  data() {
    return {
      headers: [
        { field: 'id', title: 'Id' },
        { title: 'Name', field: 'name' },
        { title: 'Total Leads', field: 'totalLeads' },
        { title: 'Completed Leads', field: 'completedLeads' },
        { title: 'Partial Leads', field: 'partialLeads' },
        { title: 'CTR (Leads)', field: 'ctrLeads' },
        { title: 'Total DP', field: 'totalDP' },
        { title: 'Mandatory DP', field: 'mandatoryDP' },
        { title: 'Collected DP', field: 'collectedDP' },
        { title: 'CTR (DP)', field: 'ctrDP' },
        { title: 'Completed DP', field: 'completedDP' },
        { title: 'CTR (DP1)', field: 'ctrCompletedDP' },
        { title: 'Partials DP', field: 'partialsDP' },
        { title: 'CTR (DP2)', field: 'ctrPartialsDP' },
        { title: 'Notes', field: 'notes' },
        { title: 'Average RT', field: 'averageRT' },
        { title: 'Min RT', field: 'minRT' },
        { title: 'Max RT', field: 'maxRT' },
        { title: 'Average CT', field: 'averageCT' },
        { title: 'Min CT', field: 'minCT' },
        { title: 'Max CT', field: 'maxCT' },
      ],
      periods: [
        {
          value: 'today',
          title: 'Today',
        },
        {
          value: 'yesterday',
          title: 'Yesterday',
        },
        {
          value: 'week',
          title: 'This week',
        },
        {
          value: 'last-week',
          title: 'Last week',
        },
        {
          value: 'month',
          title: 'This month',
        },
        {
          value: 'last-month',
          title: 'Last month',
        },
      ],
      period: 'today',
      agentId: '0',
      collections: AGENTS,
      agentsName: [],
    };
  },
  computed: {
    variables() {
      return {
        agentId: this.agentId,
        period: this.period,
      };
    },
  },
  apollo: {
    agentsName: {
      query: AGENTS_NAME,
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (!loading) {
          this.agentsName = data.agentsName.result;
        }
      },
      skip() {
        return false;
      },
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Reports/Agents.vue